module.exports = __webpack_public_path__ + "img/virusColectivo2.63096085.jpg";